import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, t as toPathString, c as serializeDataIfNeeded, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * PointCustomerApi - axios parameter creator
 * @export
 */
const PointCustomerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary An admin adds (positive points) or takes away (negative) a customer\'s points by hand, with a reason (M:BizWeb.NC.Services.ILoyaltyPoints.AdjustPointsAsync(System.Int32,System.Int32,System.String,System.Nullable{System.DateTimeOffset},System.Int32)): whole points other than 0, at most 100 000 either way, a reason of up to 200 characters, and for points added an optional expiry in the future (empty: the standard expiry). Points taken away beyond the balance become a debt. Returns the customer\'s grid row after the change. (Auth roles: System)
         * @param {LoyaltyPointsAdjustmentToken} [LoyaltyPointsAdjustmentToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustPoints: async (LoyaltyPointsAdjustmentToken, options = {}) => {
            const localVarPath = `/v1/PointCustomer/AdjustPoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(LoyaltyPointsAdjustmentToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary One row per customer with points or a reservation (M:BizWeb.NC.Services.LoyaltyBalanceQueries.Balances(BizWeb.NC.Data.BizWebDbContext,System.DateTimeOffset)): the spendable balance (unexpired rows minus open reservations, never below 0, the figure the storefront shows), the reserved points and the earliest expiry. It used to return every balance row, expired ones included, tracked and unpaged, for the admins to add up by name and e-mail. (Auth roles: System)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (loadOptions, options = {}) => {
            const localVarPath = `/v1/PointCustomer/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (loadOptions !== undefined) {
                for (const [key, value] of Object.entries(loadOptions)) {
                    localVarQueryParameter[key] = value;
                }
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary A customer\'s points history, newest first: the rows the customer\'s own loyalty page shows (M:BizWeb.NC.Services.ILoyaltyAccount.GetHistoryRowsAsync(System.Int32)), and on an adjustment its note and the admin who made it. It used to list every event, so a settled order showed its pending points next to its credit and a redemption showed as reserved and redeemed, and the two histories differed. (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryById: async (id, options = {}) => {
            const localVarPath = `/v1/PointCustomer/GetHistoryById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PointCustomerApi - functional programming interface
 * @export
 */
const PointCustomerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PointCustomerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary An admin adds (positive points) or takes away (negative) a customer\'s points by hand, with a reason (M:BizWeb.NC.Services.ILoyaltyPoints.AdjustPointsAsync(System.Int32,System.Int32,System.String,System.Nullable{System.DateTimeOffset},System.Int32)): whole points other than 0, at most 100 000 either way, a reason of up to 200 characters, and for points added an optional expiry in the future (empty: the standard expiry). Points taken away beyond the balance become a debt. Returns the customer\'s grid row after the change. (Auth roles: System)
         * @param {LoyaltyPointsAdjustmentToken} [LoyaltyPointsAdjustmentToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adjustPoints(LoyaltyPointsAdjustmentToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adjustPoints(LoyaltyPointsAdjustmentToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointCustomerApi.adjustPoints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary One row per customer with points or a reservation (M:BizWeb.NC.Services.LoyaltyBalanceQueries.Balances(BizWeb.NC.Data.BizWebDbContext,System.DateTimeOffset)): the spendable balance (unexpired rows minus open reservations, never below 0, the figure the storefront shows), the reserved points and the earliest expiry. It used to return every balance row, expired ones included, tracked and unpaged, for the admins to add up by name and e-mail. (Auth roles: System)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(loadOptions, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(loadOptions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointCustomerApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary A customer\'s points history, newest first: the rows the customer\'s own loyalty page shows (M:BizWeb.NC.Services.ILoyaltyAccount.GetHistoryRowsAsync(System.Int32)), and on an adjustment its note and the admin who made it. It used to list every event, so a settled order showed its pending points next to its credit and a redemption showed as reserved and redeemed, and the two histories differed. (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistoryById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistoryById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointCustomerApi.getHistoryById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PointCustomerApi - factory interface
 * @export
 */
const PointCustomerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PointCustomerApiFp(configuration);
    return {
        /**
         *
         * @summary An admin adds (positive points) or takes away (negative) a customer\'s points by hand, with a reason (M:BizWeb.NC.Services.ILoyaltyPoints.AdjustPointsAsync(System.Int32,System.Int32,System.String,System.Nullable{System.DateTimeOffset},System.Int32)): whole points other than 0, at most 100 000 either way, a reason of up to 200 characters, and for points added an optional expiry in the future (empty: the standard expiry). Points taken away beyond the balance become a debt. Returns the customer\'s grid row after the change. (Auth roles: System)
         * @param {LoyaltyPointsAdjustmentToken} [LoyaltyPointsAdjustmentToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustPoints(LoyaltyPointsAdjustmentToken, options) {
            return localVarFp.adjustPoints(LoyaltyPointsAdjustmentToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary One row per customer with points or a reservation (M:BizWeb.NC.Services.LoyaltyBalanceQueries.Balances(BizWeb.NC.Data.BizWebDbContext,System.DateTimeOffset)): the spendable balance (unexpired rows minus open reservations, never below 0, the figure the storefront shows), the reserved points and the earliest expiry. It used to return every balance row, expired ones included, tracked and unpaged, for the admins to add up by name and e-mail. (Auth roles: System)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(loadOptions, options) {
            return localVarFp.getAll(loadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary A customer\'s points history, newest first: the rows the customer\'s own loyalty page shows (M:BizWeb.NC.Services.ILoyaltyAccount.GetHistoryRowsAsync(System.Int32)), and on an adjustment its note and the admin who made it. It used to list every event, so a settled order showed its pending points next to its credit and a redemption showed as reserved and redeemed, and the two histories differed. (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryById(id, options) {
            return localVarFp.getHistoryById(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PointCustomerApi - object-oriented interface
 * @export
 * @class PointCustomerApi
 * @extends {BaseAPI}
 */
class PointCustomerApi extends BaseAPI {
    /**
     *
     * @summary An admin adds (positive points) or takes away (negative) a customer\'s points by hand, with a reason (M:BizWeb.NC.Services.ILoyaltyPoints.AdjustPointsAsync(System.Int32,System.Int32,System.String,System.Nullable{System.DateTimeOffset},System.Int32)): whole points other than 0, at most 100 000 either way, a reason of up to 200 characters, and for points added an optional expiry in the future (empty: the standard expiry). Points taken away beyond the balance become a debt. Returns the customer\'s grid row after the change. (Auth roles: System)
     * @param {LoyaltyPointsAdjustmentToken} [LoyaltyPointsAdjustmentToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointCustomerApi
     */
    adjustPoints(LoyaltyPointsAdjustmentToken, options) {
        return PointCustomerApiFp(this.configuration).adjustPoints(LoyaltyPointsAdjustmentToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary One row per customer with points or a reservation (M:BizWeb.NC.Services.LoyaltyBalanceQueries.Balances(BizWeb.NC.Data.BizWebDbContext,System.DateTimeOffset)): the spendable balance (unexpired rows minus open reservations, never below 0, the figure the storefront shows), the reserved points and the earliest expiry. It used to return every balance row, expired ones included, tracked and unpaged, for the admins to add up by name and e-mail. (Auth roles: System)
     * @param {DataSourceLoadOptions} [loadOptions]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointCustomerApi
     */
    getAll(loadOptions, options) {
        return PointCustomerApiFp(this.configuration).getAll(loadOptions, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary A customer\'s points history, newest first: the rows the customer\'s own loyalty page shows (M:BizWeb.NC.Services.ILoyaltyAccount.GetHistoryRowsAsync(System.Int32)), and on an adjustment its note and the admin who made it. It used to list every event, so a settled order showed its pending points next to its credit and a redemption showed as reserved and redeemed, and the two histories differed. (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointCustomerApi
     */
    getHistoryById(id, options) {
        return PointCustomerApiFp(this.configuration).getHistoryById(id, options).then((request) => request(this.axios, this.basePath));
    }
}

export { PointCustomerApi, PointCustomerApiAxiosParamCreator, PointCustomerApiFactory, PointCustomerApiFp };
//# sourceMappingURL=point-customer-api.js.map
